import Swal from 'sweetalert2'

export default {
  install: (app) => {
   
    app.config.globalProperties.$alert = async (title, text, options = {}) => {
      await Swal.fire({
        title: title || 'Aviso',
        text: text,
        icon: options.icon || null, // puedes pasar { icon: 'success' } si deseas
        confirmButtonText: 'Aceptar',
        confirmButtonColor: localStorage.getItem('color_base') || '#fd7527' ,
        customClass: {
          popup: 'text-sm',
          confirmButton: 'text-sm',
        },
        ...options, // permite sobreescribir opciones si se desea
      })
    }
  }
}
//icon: 'info' | 'success' | 'warning' | 'error' | 'question'